import React from "react";
import "../../css/Advantages_V3.css";
import { motion } from "framer-motion";
import { advantages } from "../content/text";

export const Advantages_V3 = () => {
  return (
    <section className="adv_v3_wrapper">
      <div className="adv_v3_container">
        
        <div className="adv_v3_header">
          <motion.span 
            className="v3_badge"
            initial={{ opacity: 0, letterSpacing: "10px" }}
            whileInView={{ opacity: 1, letterSpacing: "3px" }}
            viewport={{ once: true }}
          >
            Core Advantages
          </motion.span>
          <motion.h2 
            className="adv_v3_h2"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            ActoLoan <span style={{ color: "#2889a6" }}>Superiority.</span>
          </motion.h2>
        </div>

        <div className="adv_v3_matrix">
          {advantages.map((item, index) => (
            <motion.div 
              key={index}
              className="matrix_cell"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="scanline"></div>
              <div className="v3_icon_box">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              
              {/* Perpetual Corner Glow */}
              <motion.div 
                className="corner_glow"
                animate={{ opacity: [0.1, 0.3, 0.1] }}
                transition={{ duration: 3, delay: index * 0.5 }}
                style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "40px",
                    height: "40px",
                    background: "radial-gradient(circle at top right, #2889a6, transparent)",
                    pointerEvents: "none"
                }}
              />
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};
